<div class="border-bottom text-center py-4 px-10">
  <!-- Photo -->
  <app-avatar
    [Service]="Service"
    [id]="chat?.id"
    [class.avatar-online]="chat?.online"
    [type]="chat?.type"
    [avatar]="chat?.avatar"
    [avatarFileId]="chat?.avatar_file_id"
    [avatarFileUniqueId]="chat?.avatar_file_unique_id"
    class="avatar avatar-xl mx-5 mb-3"
  ></app-avatar>
  <h5>
    <ng-template [ngIf]="chat?.name?.first" [ngIfElse]="elseUserName">
      <span
        *ngIf="chat?.name?.first; else elseUserName"
        [innerHTML]="chat?.name?.first + ' ' + chat?.name?.last | replaceEmojis: 'facebook':20:64"
      ></span>
    </ng-template>
    <ng-template #elseUserName>
      <span [innerHTML]="chat?.title || chat?.username || 'Удаленный аккаунт' | replaceEmojis: 'facebook':20:64"></span>
    </ng-template>
  </h5>
  <p
    *ngIf="chat?.description"
    class="text-muted mb-2"
    [innerHTML]="chat.description | replaceEmojis: 'facebook':20:64"
  ></p>
  <a
    (click)="
      modalService.openModal('ModalChatDetailComponent', {
        Service: Service,
        id: Service.openChatId,
        initData: Service.openChat
      })
    "
    class="btn btn-outline-dark btn-sm py-2"
  >
    <i-feather name="user"></i-feather> Смотреть профиль
  </a>
</div>
